export default {
    // 活动详情接口
    getActivityDetail: '/member/anonymous/amc/getActivityById',
    // 通过活动Id和用户Id获取会员的报名状况
    getApplyStatus: '/member/anonymous/amc/getApplyStatus',
    // 通过活动Id和电话获取会员的报名状况
    getApplyStatusByActivityIdAndPhone: '/member/anonymous/amc/getApplyStatusByActivityIdAndPhone',
    // 获取用户报名详细（基础信息和动态字段信息）
    getApplyMemberDetail: '/member/anonymous/amc/getApplyMemberDetail',
    // 获取报名自定义表单
    getApplyMemberModelByActivityId: '/member/anonymous/amc/getApplyMemberModelByActivityId',
    // 会员报名
    addApplyMember: '/member/anonymous/amc/addApplyMember',
    // 会员报名并签到
    addApplyMemberAndSignIn: '/member/anonymous/amc/addApplyMemberAndSignIn',
    // 获取参赛作品自定义表单
    getApplyFormModelByActivityId: '/member/anonymous/amc/getApplyFormModelByActivityId',
    // 会员提交参赛作品
    addApplyForm: '/member/anonymous/amc/addApplyForm',
    // 会员修改参赛作品
    updateApplyFormForYTH: '/member/anonymous/amc/updateApplyFormForYTH',
    // H5签到页面获取短信验证码
    getAuthCodeBySignIn: '/member/anonymous/amc/getAuthCodeBySignIn',
    // 签到
    activitySignInByPhone: '/member/anonymous/amc/activitySignInByPhone',
    // 根据活动ID和会员ID判断是否已经签到
    isSignIn: '/member/anonymous/amc/isSignIn',

    // 根据活动Id查询参赛作品列表
    listApplyFormByActivityId: '/member/anonymous/amc/listApplyFormByActivityId',
    // 根据活动Id查询参赛作品列表
    listApplyFormByCondition: '/member/anonymous/amc/listApplyFormByCondition',
    // 根据活动Id和会员Id查询参赛作品列表
    listApplyFormByMemberId: '/member/anonymous/amc/listApplyFormByMemberId',
    // 参赛作品投票
    topApplyForm: '/member/anonymous/amc/topApplyForm',
    // 参赛作品详情
    getApplyFormDetail: '/member/anonymous/amc/getApplyFormDetail',
}